import React from 'react'

import { RotateSpinner } from 'react-spinners-kit'

import { useTheme } from '@mui/material'

interface LoadingSpinnerProps {
  color?: string
  size?: number
}

const LoadingSpinner = React.forwardRef(
  (props: LoadingSpinnerProps, ref: any) => {
    const { color, size } = props
    const theme = useTheme()

    return (
      <RotateSpinner
        ref={ref}
        size={size ?? 24}
        // react-spinners-kit relies on defaultProps for sizeUnit, which
        // React 19 ignores on function components — without it the spinner
        // renders with invalid CSS sizes and becomes invisible.
        sizeUnit="px"
        color={color ?? theme.palette.primary.main}
        loading={true}
      />
    )
  }
)

LoadingSpinner.displayName = 'LoadingSpinner'
export default LoadingSpinner
